import { useTranslation } from "react-i18next";
import React from 'react';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';
import SelectInput from './SelectInput';

const FieldRouter = ({
  value,
  setValue,
  row,
  error
}) => {
  const {
    t
  } = useTranslation();
  const {
    name,
    fields,
    types
  } = row; // Handle properties with predefined types (dropdowns)

  if (types && Array.isArray(types)) {
    return <FormGroup>
        <Label>{t(row.showName)}</Label>
        <SelectInput value={value || ''} setValue={setValue} options={types} error={error} />
      </FormGroup>;
  } // Handle properties with multiple fields (phone, email, address, etc.)


  if (fields) {
    return <div>
        {Object.entries(fields).filter(([key]) => key !== '' && key != null).map(([key, field]) => <FormGroup key={key}>
            <Label>{t(field.showName)}</Label>
            {field.types && Array.isArray(field.types) ? <Input type="select" value={value?.[key]?.value || ''} onChange={e => {
          const newValue = { ...(value || {})
          };

          if (!newValue[key]) {
            newValue[key] = {};
          } else {
            // Create a new object to avoid read-only property issues
            newValue[key] = { ...newValue[key]
            };
          }

          newValue[key].value = e.target.value;
          setValue(newValue);
        }} invalid={error && error[field.name]} style={{
          color: '#000'
        }}>
                <option value="">{t("-- Choose")}{field.showName} --</option>
                {field.types.map(type => <option key={type} value={type}>{type}</option>)}
              </Input> : <Input type={getInputType(field.name)} value={value?.[key]?.value || ''} onChange={e => {
          const newValue = { ...(value || {})
          };

          if (!newValue[key]) {
            newValue[key] = {};
          } else {
            // Create a new object to avoid read-only property issues
            newValue[key] = { ...newValue[key]
            };
          }

          newValue[key].value = e.target.value;
          setValue(newValue);
        }} invalid={error && error[field.name]} style={{
          color: '#000'
        }} />}
            {error && error[field.name] && <FormFeedback>{error[field.name]}</FormFeedback>}
          </FormGroup>)}
      </div>;
  } // Handle simple text properties


  const getDisplayValue = () => {
    if (name === 'onmymind') {
      console.log('FieldRouter onmymind - name:', name, 'value:', value, 'type:', typeof value); // Handle onmymind property - extract the text value from parameters

      if (value && typeof value === 'object') {
        if (value.parameters && value.parameters['1'] && value.parameters['1'].value) {
          console.log('FieldRouter onmymind - extracted from parameters:', value.parameters['1'].value);
          return value.parameters['1'].value;
        } else if (value.value && typeof value.value === 'string') {
          console.log('FieldRouter onmymind - extracted from value.value:', value.value);
          return value.value;
        } else if (value.value && typeof value.value === 'object' && value.value.value) {
          console.log('FieldRouter onmymind - extracted from value.value.value:', value.value.value);
          return value.value.value;
        }
      }

      console.log('FieldRouter onmymind - returning value as string:', String(value || ''));
      return value || '';
    }

    return value || '';
  };

  return <FormGroup>
      <Label>{t(row.showName)}</Label>
      <Input type={getInputType(name)} value={getDisplayValue()} onChange={e => setValue(e.target.value)} invalid={!!error} style={{
      color: '#000'
    }} />
      {error && <FormFeedback>{error}</FormFeedback>}
    </FormGroup>;
};

const getInputType = fieldName => {
  switch (fieldName) {
    case 'number':
    case 'phone':
      return 'tel';

    case 'url':
      return 'url';

    case 'date':
    case 'birthday':
      return 'date';

    case 'email':
    case 'address':
      return 'email';

    case 'onmymind':
    case 'note':
    case 'personalNote':
    case 'dadjokes':
    case 'trivia':
    case 'facts':
    case 'motivational':
    case 'conversation':
    case 'educational':
    case 'jokes':
      return 'textarea';

    default:
      return 'text';
  }
};

export default FieldRouter;